import type { FilterState, Place } from "../data/schema";
import { regionById } from "../data/regions";
import { regionLabels } from "./labels";

export function filterPlaces(places: Place[], filters: FilterState) {
  const query = filters.query.trim().toLowerCase();

  return places.filter((place) => {
    if (query) {
      const haystack = [
        place.name,
        place.summary,
        place.dadTip,
        place.address,
        place.region,
        regionLabels[place.region],
        place.district,
        place.neighborhood,
        place.tags.join(" "),
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(query)) return false;
    }

    if (filters.regions.length && !filters.regions.includes(place.region)) {
      return false;
    }

    if (
      filters.areaGroups.length &&
      !filters.areaGroups.includes(regionById[place.region].areaGroup)
    ) {
      return false;
    }

    if (filters.categories.length && !filters.categories.includes(place.category)) {
      return false;
    }

    if (filters.weekdays.length) {
      const hasOpenDay = filters.weekdays.some((weekday) =>
        place.openDays.includes(weekday),
      );
      if (!hasOpenDay) return false;
    }

    if (filters.districts.length && !filters.districts.includes(place.district)) {
      return false;
    }

    if (filters.indoorOutdoor !== "all" && place.indoorOutdoor !== filters.indoorOutdoor) {
      if (!(filters.indoorOutdoor === "indoor" && place.indoorOutdoor === "mixed")) {
        return false;
      }
    }

    if (filters.priceType !== "all" && place.priceType !== filters.priceType) {
      if (!(filters.priceType === "free" && place.priceType === "mixed")) {
        return false;
      }
    }

    if (place.ageFit < filters.minAgeFit) return false;
    if (filters.rainFriendlyOnly && !place.rainFriendly) return false;
    if (filters.stayTimes.length && !filters.stayTimes.includes(place.stayTime)) {
      return false;
    }

    return true;
  });
}

export function toggleArrayValue<T>(values: T[], value: T) {
  return values.includes(value)
    ? values.filter((item) => item !== value)
    : [...values, value];
}
